import { ProductMediaFilesProvider } from "./FilesContext";
import FilesList from "./FilesList";
import AddFileButtons from "./AddFileButtons";
import ModalVideoProvider from "@admin/components/ModalVideo";
import { ProductMediaModel } from "@admin/domain/products/models/edit/ProductAttributesModel";

export default function ProductMediaFiles({ files }: { files: ProductMediaModel[] }) {
    return (
        <ProductMediaFilesProvider filesInit={files}>
            <div className="rounded border p-10 mb-5">
                <h2>Изображения и видео</h2>
                <AddFileButtons />
                <ModalVideoProvider>
                    <FilesList />
                </ModalVideoProvider>
            </div>
        </ProductMediaFilesProvider>
    );
}
